//
// Software Name: Orange Design System Charts
// SPDX-FileCopyrightText: Copyright (c) 2023 - 2026 Orange SA
// SPDX-License-Identifier: MIT
//
// This software is distributed under the MIT license.
//
export const COMMON_LINE_STYLE_POINTS = {
    line: {
        itemStyle: {
            borderWidth: 1,
        },
        symbolSize: 10,
        symbol: 'circle',
    },
};
